<template>
	<div class="flex p-0.25 space-x-2 items-center max-w-full truncate whitespace-nowrap min-w-0">
		<div v-if="user" class="relative shrink-0 w-8 text-0">
			<a v-if="user" :href="user.url" class="block h-8 w-9">
				<avatar :ava="user.ava" class="w-8 h-8"></avatar>
			</a>
			<a :href="channel.url" class="block h-4 w-4 absolute -bottom-0.5 -right-0.5">
				<avatar :ava="channel.ava" class="w-4 h-4"></avatar>
			</a>
		</div>
		<a v-else :href="channel.url" class="shrink-0 h-8 w-8">
			<avatar :ava="channel.ava" class="w-8 h-8"></avatar>
		</a>
		<div class="leading-tight min-w-0">
			<div v-if="user" class="flex flex-col">

				<a :href="user.url"
				   class="text-black dark:text-white font-medium flex items-center gap-2">
					<span class="hover:opacity-70">{{ user.name }}</span>

					<svg-icon
						v-if="user.is_verified"
						icon="check-circle-fill"
						class="w-3 h-3 text-blue-500 shrink-0"
					></svg-icon>
				</a>

				<a :href="channel.url" class="text-black dark:text-white text-sm hover:opacity-70">
					{{ channel.name }}
				</a>
			</div>

			<a v-else :href="channel.url" class="text-black dark:text-white font-medium ">
				{{ channel.name }}
			</a>
		</div>
	</div>
</template>
<script>
import User from "../../js/modules/User";
import Avatar from "./Avatar.vue";
import UserLink from "../user/UserLink.vue";

export default {
	components: {UserLink, Avatar},
	props: ['channel', 'user'],
	data() {
		return {
			currentUser: new User(),
		};
	},
	methods: {
		inlineBg(ava) {
			return ava ? {backgroundImage: `url(${ava})`} : '';
		},
	}
}
</script>
